import useCrud from 'hooks/useCrud';
import { detail } from 'services/api/review';

function useDetail() {
  return useCrud({
    read: detail,
  });
}

export default useDetail;
